import { createRecipe } from './runtime';

const linkConfig = {"name":"link","variantMap":{"variant":["standalone"]}}

export const link = /* @__PURE__ */ createRecipe(linkConfig)